import http from 'utils/http';

export const fetchMyOrganizations = (query) => http.get(`v1/organizations/mine/${query ? `?search=${query}` : ''}`).then((res) => res.data);
export const fetchOrganizationConfig = () => http.get('v1/organization/{{organizationId}}/configs/').then((res) => res.data);
export const fetchOrganizationDetails = (organizationId) => http.get(`v1/organizations/${organizationId}/`).then((res) => res.data);
